export default [
    {
        path: '/tarife-yonetimi',
        name: 'tarife-yonetimi',
        meta: { resource: 'admin',key: 'tarife-yonetimi' },
        component: () => import('../views/tariff/list'),
    }
] 